import { isRtlLangue, getCurrentLang } from '@tt4b/ttam-utils';
import { setGlobalConfig } from '@okee-uikit/web-components-vue';

export function convertContentToStr(content) {
  if (content instanceof Array) {
    const arr = content.map(item => convertContentToStr(item));
    return arr.sort().join('');
  } else if (content instanceof Object) {
    const keys = Object.keys(content).sort();
    const sortContent = keys.reduce((pre, cur) => {
      pre[cur] = convertContentToStr(content[cur]);
      return pre;
    }, {});
    return JSON.stringify(sortContent);
  } else {
    return String(content);
  }
}

export function setDocsBodyDir() {
  const div = document.getElementsByClassName('by-docs-body')[0];
  if (isRtlLangue()) {
    div.setAttribute('dir', 'rtl');
  } else {
    div.setAttribute('dir', 'ltr');
  }
}
export async function loadLocaleLang() {
  try {
    const lang = getCurrentLang();
    const LOCALE = (await import(`@okee-uikit/web-components-locales/dist/${lang}.js`)).default;
    setGlobalConfig({ locale: LOCALE });
  } catch (error) {
    // 上报个日志
    console.log('wx error');
  }
}


export * from './string-utils';
export * from './track';
export * from './tree-utils';
export * from './interest-utils';
